import * as React from 'react'

import { Loading } from '@makyoapp/makyo-ui'

import lazyload from './lazy-load'
import type { Loader } from './lazy.types'

/**
 * Lazyload utility for page component.
 * It uses default `Loading` component as fallback.
 */
export default function lazyPage<P = {}>(loader: Loader<P>) {
  // invoke lazy import from loader
  const PageComponent = lazyload(loader, {
    loading: () => <Loading fullHeight />,
  })

  return PageComponent as React.ComponentType<P>
}
